export const allDoctypes = (state = {}, action) => {
    switch (action.type) {
        case 'SET_ALLDOCTYPE':
            state = action.payload;
            return state;
        default:
            return state;
    }
}

export const nfuDocs = (state = {}, action) => {
    switch (action.type) {
        case 'SET_NFUDOCS':
            state = action.payload;
            return state;
        default:
            return state;
    }
}

export const doctypeTranslations = (state = {}, action) => {
    switch (action.type) {
        case 'SET_DOCTYPETRANSLATIONS':
            state = action.payload;
            return state;
        default:
            return state;
    }
}